module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "url-button",
    on: {
      "click": _vm.onClick
    }
  }, [((_vm.crud === 'vds' || _vm.crud === 'domains' || _vm.crud === 'operation') &&
    (_vm.name === 'sshkey_id' || _vm.name === 'create_iso' || _vm.name === 'person_id' || _vm.name === 'payer')) ? _c('font-awesome-icon', {
    attrs: {
      "icon": "plus-circle"
    }
  }) : _vm._e(), _vm._v("\n\t" + _vm._s(_vm._f("ftc")(_vm.text)) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d93fd768"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/urlbtn.vue
// module id = 397
// module chunks = 0